<template>
  <Teleport to="#Teleport-alerts-destination">
    <transition name="fade">
      <div
        v-show="isVisible"
        :class="{'isGlobalFlashNotice': isGlobalFlashNotice}"
        class="FlashNotice"
      >
        <div
          :class="noticeType"
          class="Notice"
        >
          {{ message }}
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
export default {
  props: {
    isGlobalFlashNotice: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      noticeTypes: {
        Warning: 'Notice--warning',
        Error: 'Notice--danger',
        Info: 'Notice--info',
        Success: 'Notice--success',
      },
      timeout: null,
      type: 'Info',
      message: 'Base Alert message!!',
      isVisible: false,
    };
  },
  computed: {
    noticeType() {
      return this.noticeTypes[this.type];
    },
  },

  watch: {
    timeout: {
      handler(curr, prev) {
        if (prev) {
          clearTimeout(prev);
        }
      },
    },
  },
  created() {
    this.$bus.$on('bus:base-alert', (data) => {
      if (this.isVisible) {
        this.isVisible = false;
      }
      this.timeout = setTimeout(() => {
        this.isVisible = false;
      }, 4000);

      // Optional prop for scroll to top once alert shows.
      // Default undefined so no need to set for every alert.
      if (data.stopScrollToTop !== true) {
        window.scroll(0, 0);
      }

      setTimeout(() => {
        this.type = data.type;
        this.message = data.message;
        this.isVisible = true;
      }, 500);
    });
  },
};
</script>
<style lang="scss" scoped>
  @import '../../../scss/abstracts/abstracts.scss';

    .FlashNotice {
      position: absolute;
      top: 70px;
      @include respond-to(sm, max-width) {
        margin: 0 !important;
      }
        overflow-y: unset;
        width: 100%;
        padding: 0 !important;
        z-index: 5;

      &.isGlobalFlashNotice {
        padding: 0;
        top: 71px!important;
      }
    }

    .fade-enter-active{
      transition: opacity .5s;
    }
    .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
</style>
